import { render } from "./PracticalActivitePage.vue?vue&type=template&id=0299203a&scoped=true"
import script from "./PracticalActivitePage.vue?vue&type=script&lang=js"
export * from "./PracticalActivitePage.vue?vue&type=script&lang=js"

import "./PracticalActivitePage.vue?vue&type=style&index=0&id=0299203a&scoped=scoped&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0299203a"]])

export default __exports__